window.CalendarBackground = function () {
    var el = this;
    var isMoving = false;
    var elsList = {};

    function onloadImage (data, item, image) {
        var id = 0;
        var pos = {
            x: 0,
            y: 0,
            width: item.width,
            height: item.height
        };

        pos = el.upImages.setImagePosition(image.width, image.height, pos);

        pos.name = image.name;
        pos.type = 'custom';
        pos.data_width = image.width;
        pos.data_height = image.height;

        if (el._parent.hasOwnProperty('isTemplater')) {
            pos.type = 'template';
            pos.theme_id = window.bookSid;
        }

        if (data.backgrounds.hasOwnProperty(id) && data.backgrounds[id] !== null) {
            el.upImages.unsetUsedImage(image.name);
        }

        data.backgrounds[id] = pos;

        el.history.add();
    };

    /**
     *
     * @param {Event} event
     */
    el.beginMove = function (event) {
        event.preventDefault();
        var selectedId = el.calendarSelect.selectId;
        isMoving = true;
        el._parent.isTransforming = true;

        var element = document.getElementById('backgrounds-item-' + selectedId);

        elsList = {
            element: element,
            coord: el.transform.getPosition(element),
            pos: el.transform.getPosition(element),
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0
        };
    };

    el.move = function (event) {
        if (isMoving) {
            var selectedId = el.calendarSelect.selectId;
            var selectedResources = el.calendarGrid.getSelectedNumberResources();
            var selectedNumber = el.calendarGrid.getSelectedNumber();

            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            movementX /= el.calendarGrid.numberScale;
            movementY /= el.calendarGrid.numberScale;

            if (
                    0 >= parseInt(elsList.pos.x) + movementX &&
                    selectedNumber.width <= parseInt(elsList.pos.x) + parseInt(elsList.pos.width) + movementX &&
                    0 >= parseInt(elsList.pos.y) + movementY &&
                    selectedNumber.height <= parseInt(elsList.pos.y) + parseInt(elsList.pos.height) + movementY
                    ) {

                elsList.x += movementX;
                elsList.y += movementY;

                var image = selectedResources.backgrounds[selectedId];
                var element = elsList.element;

                var pos = {
                    x: parseInt(elsList.coord.x + elsList.x),
                    y: parseInt(elsList.coord.y + elsList.y)
                };

                el.transform.setPosition(element, pos.x, pos.y);

                var rotate = el.transform.getRotate(element);
                image.rotate_angle = rotate.angle;
                image.rotate_x = rotate.x;
                image.rotate_y = rotate.y;

                image.x = pos.x;
                image.y = pos.y;

                elsList.pos.x = pos.x;
                elsList.pos.y = pos.y;

                el.calendarSelect.update(element);
            }
        }
    };

    el.endMove = function () {
        if (isMoving) {
            isMoving = false;
            el.history.add();
        }
    };

    el.rotate = function (angle) {
        var item = el.calendarGrid.getSelectedNumberResources();
        var selectedId = el.calendarSelect.selectId;

        var image = item.backgrounds[selectedId];
        var element = document.getElementById('backgrounds-item-' + el.selectId);

        el.transform.addRotate(element, angle);

        var rotate = el.transform.getRotate(element);
        image.rotate_angle = rotate.angle;
        image.rotate_x = rotate.x;
        image.rotate_y = rotate.y;

        el.calendarSelect.update(element);

        el.history.add();
    };

    el.resize = function (diff) {
        var selectedResources = el.calendarGrid.getSelectedNumberResources();
        var selectedNumber = el.calendarGrid.getSelectedNumber();
        var selectedId = el.calendarSelect.selectId;
        var data = {};

        var globalPos, pos = {}, workareaPos;

        var image = selectedResources.backgrounds[selectedId];
        var ratio = image.width / image.height;

        globalPos = {
            x: 0,
            y: 0,
            width: selectedNumber.width,
            height: selectedNumber.height
        };

        pos.x = image.x;
        pos.y = image.y;
        pos.width = image.width;
        pos.height = image.height;

        data.x = parseInt(pos.x) - diff;
        data.y = parseInt(pos.y) - parseInt(diff / ratio, 10);
        data.width = parseInt(pos.width) + 2 * diff;
        data.height = parseInt(pos.height) + parseInt(2 * diff / ratio, 10);

        workareaPos = $.extend(true, {}, data);

        updateData(globalPos, data, workareaPos);


        function updateData(globalPos, data, workareaPos) {
            var item = el.calendarGrid.getSelectedNumberResources();
            var selectedId = el.calendarSelect.selectId;
            var element = document.getElementById('backgrounds-item-' + selectedId);
            var image = item.backgrounds[selectedId];

            var valvePos = {
                x: data.x,
                y: data.y,
                width: data.width,
                height: data.height
            };

            if (
                (globalPos.x >= valvePos.x &&
                    parseInt(globalPos.x) + parseInt(globalPos.width) <= parseInt(valvePos.x) + parseInt(valvePos.width) &&
                    globalPos.y >= parseInt(valvePos.y) &&
                    parseInt(globalPos.y) + parseInt(globalPos.height) <= parseInt(valvePos.y) + parseInt(valvePos.height))
                || image.hasOwnProperty('mask')
            ) {

                image.x = workareaPos.x;
                image.y = workareaPos.y;
                image.width = workareaPos.width;
                image.height = workareaPos.height;

                element.setAttribute('width', workareaPos.width);
                element.setAttribute('height', workareaPos.height);
                element.setAttribute('x', workareaPos.x);
                element.setAttribute('y', workareaPos.y);
            }
        }

        var element = document.getElementById('backgrounds-item-' + selectedId);
        el.calendarSelect.update(element);

        el.history.add();
    };

    el.remove = function () {
        var item = el.calendarGrid.getSelectedNumberResources();
        var selectedId = el.calendarSelect.selectId;

        if (el._parent.hasOwnProperty('upImages')) {
            el.upImages.unsetUsedImage(item.backgrounds[selectedId].name);
        }

        delete item.backgrounds[selectedId];

        el.calendarSelect.hide();
        el.history.add();
    };

    el.upload = function(name) {
        var selectedResources = el.calendarGrid.getSelectedNumberResources();
        var selectedNumber = el.calendarGrid.getSelectedNumber();

        el.loader.show(Yii.t('Loading picture...'), false);

        var image = new Image();
        var url = window.location.origin + el.projectsPath + '/' + window.bookSid + '/workimages/' + name;

        if (el._parent.hasOwnProperty('isTemplater')) {
            url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/templates/' + window.bookSid + '/workimages/' + name;
        }

        image.onload = function () {
            el.upImages.setUsedImage(this.name);
            onloadImage(selectedResources, selectedNumber, this);
            el.loader.hide();
            $('#calendar-modal').removeClass('upload-mode');
            el.dialog.show('calendar');
        };

        image.onerror = function () {
            el.loader.hide();
            $('#calendar-modal').removeClass('upload-mode');
            alert(Yii.t('The selected image did not load'));
        };

        image.src = url;
        image.name = name;
    };

    el.checkUpload = function(file) {
        if ($('#calendar-modal').hasClass('upload-mode')) {
            el.upload(file.filename);
        }
    };

    $(document).on('click', '.js-calendar-background-upload', function(e) {
        $('#calendar-modal').addClass('upload-mode');
        el.dialog.hide('calendar');
        el.upImages.show(e);
    });
};
